import style from './index.module.scss';
import clsx from 'clsx';

function ButtonTag({ ...props }) {
    const Wrapper = props.link ? 'button' : 'div';
    return (
        <Wrapper className={clsx(style.block, props.link && style.link, props.selection && style.selection)}>
            {props.text}
        </Wrapper>
    );
}

export default ButtonTag;
